import { Link } from 'react-router-dom';
import {
  ChevronDownIcon,
  UserIcon,
  UsersIcon,
  BookOpenIcon,
  UserGroupIcon,
  PaintBrushIcon,
  BookmarkIcon,
} from '@heroicons/react/24/outline';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from '@/components/ui/popover';
import { Small } from '@/components/Typography';
import { layoutMessages } from './Sidebar.messages';
import { ROUTES } from '@/routes';
import { SidebarSection } from '@/components/layout/SidebarSection';
import { useAuth } from '@/hooks/useAuth';

export function Sidebar() {
  const { session, isAdmin, signOut } = useAuth();

  const navigation = [
    {
      name: layoutMessages.storyTemplates,
      href: ROUTES.DASHBOARD_STORY_TEMPLATES,
      icon: BookOpenIcon,
    },
    {
      name: layoutMessages.generatedStories,
      href: ROUTES.DASHBOARD_GENERATED_STORIES,
      icon: BookmarkIcon,
    },
    {
      name: layoutMessages.characters,
      href: ROUTES.DASHBOARD_CHARACTERS,
      icon: UsersIcon,
    },
  ];

  const adminNavigation = [
    {
      name: layoutMessages.roleTemplates,
      href: ROUTES.DASHBOARD_ROLE_TEMPLATES,
      icon: UserGroupIcon,
    },
    {
      name: layoutMessages.styleTemplates,
      href: ROUTES.DASHBOARD_STYLE_TEMPLATES,
      icon: PaintBrushIcon,
    },
  ];

  return (
    <div className="flex h-screen w-64 flex-col border-r border-stone-200 bg-gradient-to-br from-purple-200 via-pink-200 to-orange-200">
      {/* Header - Logo */}
      <div className="flex-shrink-0">
        <div className="flex h-16 items-center px-6">
          <Link to={ROUTES.HOME} className="flex items-center space-x-2">
            <img
              src="/logo/wfsc-logo-with-flair-horizontal.png"
              alt={layoutMessages.logoAlt}
              className="object-contain"
            />
          </Link>
        </div>
      </div>

      {/* Content - Navigation */}
      <div className="flex-1 overflow-y-auto">
        <nav className="px-4 py-4">
          <SidebarSection title="Main" items={navigation} />

          {/* Admin Section */}
          {isAdmin && (
            <div className="mt-8">
              <SidebarSection
                title={layoutMessages.adminSection}
                items={adminNavigation}
              />
            </div>
          )}
        </nav>
      </div>

      {/* Footer - User Profile */}
      <div className="flex-shrink-0">
        <div className="p-4">
          <Popover>
            <PopoverTrigger asChild>
              <Button
                type="button"
                variant="ghost"
                className="flex w-full items-center justify-start space-x-2"
              >
                <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-stone-300">
                  <UserIcon className="h-4 w-4 text-stone-600" />
                </div>
                <Small className="flex-1 truncate text-left text-stone-700">
                  {session?.user?.email || 'User'}
                </Small>
                <ChevronDownIcon className="h-4 w-4 flex-shrink-0 text-stone-400" />
              </Button>
            </PopoverTrigger>
            <PopoverContent side="top" align="start" className="w-56 p-1">
              <Button
                type="button"
                variant="ghost"
                onClick={signOut}
                className="w-full justify-start rounded-md"
              >
                {layoutMessages.logout}
              </Button>
            </PopoverContent>
          </Popover>
        </div>
      </div>
    </div>
  );
}
